import Vue from "vue";
import base from "./baseCore";

export default Object.assign(
    {
        apiUrl: "/local",
        urlAdmin: "/local",

        async search({ filtro = "", page = 0 } = {}) {
            const url = this.userUrl({ path: `/search/${page}` });

            const nodeList = await Vue.http.get(url, {
                params: {
                    filtro
                }
            });

            return nodeList;
        },

        async adminSearch({ filtro = "", page = 0 } = {}) {
            const url = this.adminUrl(`/search/${page}`);

            const nodeList = await Vue.http.get(url, {
                params: {
                    filtro
                }
            });

            return nodeList;
        },

        async openNode({ nodeId, type, page = 0, filtro = "" } = {}) {
            const url = this.userUrl({
                path: `/open/${nodeId}/${type}/${page}`
            });

            const nodeList = await Vue.http.get(url, {
                params: {
                    filtro
                }
            });

            return nodeList;
        },

        async adminOpenLocal({ id, page = 0, filtro = "" } = {}) {
            const url = this.adminUrl(`/${id}/open/${page}`);

            const nodeList = await Vue.http.get(url, {
                params: {
                    filtro
                }
            });

            return nodeList;
        }
    },
    base
);
